import React, { Fragment } from 'react';
import GridCellWrapper from '../../../components/grid-cell-wrapper/GridCellWrapper';
import Zeitstrahl from './Zeitstrahl/Zeitstrahl';
import Transportauftraege from './Transportauftraege/Transportauftraege';
import { withRouter } from 'react-router-dom';

/**
 * Dispositions-Component
 *
 * @returns {JSX.Element} Dispositions-Component
 * @constructor
 */
const Disposition = () => {
  return (
    <Fragment>
      <div className='dispo-wrapper'>
        <Zeitstrahl />
        <Transportauftraege />
        <GridCellWrapper
          classes='karte'
          label='Karte'
          saveUserAnsicht={() => {
            null;
          }}
        >
          <img className='map' src={process.env.PUBLIC_URL + '/map.jpg'} />
        </GridCellWrapper>
      </div>
    </Fragment>
  );
};

export default withRouter(Disposition);
